import { render, staticRenderFns } from "./PosProductList.vue?vue&type=template&id=3370bd63&scoped=true&"
import script from "./PosProductList.vue?vue&type=script&lang=js&"
export * from "./PosProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3370bd63",
  null
  
)

export default component.exports